import React from 'react';
import { ReactComponent as BellIcon } from '../../../icons/bell-ringing-03.svg';
import FreeTextGuidanceBox from './FreeTextGuidanceBox';

interface AlertsTabProps {
  /** Saved WhatsApp alert instructions, or null when none are set. */
  description: string | null;
  onSave: (value: string | null) => void;
}

const ALERTS_EDIT_PLACEHOLDER =
  'e.g. Any failed payment, or anything where a customer is unhappy. Not recruitment.';

const ALERTS_EXAMPLES = [
  'A payment failing',
  'A meeting in the next 48h',
  'An unhappy customer',
  'Anything from an investor',
];

const AlertsTab: React.FC<AlertsTabProps> = ({ description, onSave }) => (
  <div className='inbox-tab alerts-tab'>
    <div className='section-header'>
      <h2>Alerts</h2>
    </div>

    <FreeTextGuidanceBox
      value={description}
      onSave={onSave}
      label='Alert me on WhatsApp about'
      editPlaceholder={ALERTS_EDIT_PLACEHOLDER}
      exampleChips={ALERTS_EXAMPLES}
      saveLabel='Save alerts'
      clearLabel='Clear alerts'
      testId='notification-preferences'
      renderEmpty={(startEditing) => (
        <div className='app-empty-state' data-testid='alerts-empty'>
          <BellIcon className='app-empty-icon' />
          <p className='app-empty-title'>You&apos;ve not set any alerts</p>
          <p className='app-empty-blurb'>
            Get alerted for vital emails straight away. You can get instant
            WhatsApp alerts for certain types of emails, everything else waits
            for your Daily Briefing.
          </p>
          <button
            type='button'
            className='btn'
            onClick={startEditing}
            data-testid='alerts-setup'
          >
            Set up Alerts
          </button>
        </div>
      )}
    />
  </div>
);

export default AlertsTab;
